// This file was automatically generated from ptdata.model.attachment.html.
// Please don't edit this file by hand.

goog.provide('el8.template.ptdata.model.attachment');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.attachment.summary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.originalFilename) ? soy.$$escapeHtml(opt_data.originalFilename) : (opt_data.contentType) ? soy.$$escapeHtml(opt_data.contentType) + ' File' : 'Attachment');
  if (!opt_sb) return output.toString();
};
